import { useContext } from 'react';

import type { AppContextValue } from '@system/app/context';
import { AppContext } from '@system/app/context';

export const useApp = (): AppContextValue => {
  return useContext(AppContext);
};
